import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { useTheme } from '@mui/styles'
import Input from 'components/generic/form/Input'

const PrintInput = ({ name, label, control, xs, ...restProps }) => {
  const theme = useTheme()
  return (
    <Grid item mb={3} xs={xs}>
      <Input
        xs={4}
        variant="standard"
        disabled
        defaultValue=""
        name={name}
        label={label}
        control={control}
        sx={{
          'input.Mui-disabled': {
            WebkitTextFillColor: theme.palette.text.primary,
          },
          'textarea.Mui-disabled': {
            WebkitTextFillColor: theme.palette.text.primary,
          },
          'label.Mui-disabled': {
            WebkitTextFillColor: theme.palette.text.secondary,
          },
        }}
        InputProps={{
          disableUnderline: true,
        }}
        {...restProps}
      />
    </Grid>
  )
}

PrintInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  xs: PropTypes.number,
}

PrintInput.defaultProps = {
  xs: 4,
}

export default PrintInput
